import React from 'react';
import { clsx } from 'clsx';

export const KnowledgeBaseLabel = ({ enabled = false }) => {
  return (
    <span
      className={clsx(
        'text-[10px] rounded-[50px] py-1 px-2.5 pointer-events-none',
        enabled ? 'text-[#7A6BE5] bg-[#F3F2FF]' : 'text-ebony_opacity_50 bg-[#F1F6F6]',
      )}
    >
      {enabled ? 'Enabled' : 'Disabled'}
    </span>
  );
};
